// Menu category data
export const foodCategories = [
  {
    foodTitle: "Meal Deals",
    foodImage: "/images/foodHeaders/MealDeals.png",
    alt: "Meal Deals Photo",
  },
  {
    foodTitle: "Burgers",
    foodImage: "/images/foodHeaders/Burgers.png",
    alt: "Burgers Photo",
  },
  {
    foodTitle: "Sandwiches",
    foodImage: "/images/foodHeaders/Sandwiches.png",
    alt: "Sandwiches Photo",
  },
  {
    foodTitle: "Mexican",
    foodImage: "/images/foodHeaders/Mexican.png",
    alt: "Mexican Food Photo",
  },
  {
    foodTitle: "Chicken Nuggets",
    foodImage: "/images/foodHeaders/Nuggets.png",
    alt: "Chicken Nuggets Photo",
  },
  {
    foodTitle: "Wings",
    foodImage: "/images/foodHeaders/Wings.png",
    alt: "Wings Photo",
  },
  {
    foodTitle: "Side Orders",
    foodImage: "/images/foodHeaders/sideOrders.png",
    alt: "Side Orders Photo",
  },
  {
    foodTitle: "Drinks",
    foodImage: "/images/foodHeaders/Beverages.png",
    alt: "Drinks Photo",
  },
  {
    foodTitle: "Desserts",
    foodImage: "/images/foodHeaders/Desserts.png",
    alt: "Desserts Photo",
  },
  {
    foodTitle: "Salads",
    foodImage: "/images/foodHeaders/Salads.png",
    alt: "Salads Photo",
  },
  {
    foodTitle: "Blended",
    foodImage: "/images/foodHeaders/Blended.png",
    alt: "Blended Photo",
  },
];

export const defaultThumbnail = "/images/defaultfoodicon.png";
export const defaultAlt = "Default Meal Photo";

// Category name mapping
export const getCategoryName = (foodId, templateId) => {
  const rioLindaCategories = [
    "Meal Deals",
    "Burgers",
    "Sandwiches",
    "Mexican",
    "Chicken Nuggets",
    "Side Orders",
    "Drinks",
    "Desserts",
    "Salads",
    "Blended",
  ];

  const ranchoCategories = [
    "Meal Deals",
    "Burgers",
    "Sandwiches",
    "Mexican",
    "Chicken Nuggets",
    "Wings",
    "Side Orders",
    "Drinks",
    "Desserts",
    "Salads",
    "Blended",
  ];

  const categories = templateId === "1" ? rioLindaCategories : ranchoCategories;
  return categories[foodId] || null;
};

// Import and re-export setContent function from menuContentData
export { getMenuContent } from "./menuContentData";

